// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Button from './button';
import Icon from './icon';
import OverlayTrigger from './overlay-trigger';

// Styles
import './dropdown.scss';

export default class Dropdown extends Component {
    getButtonProps() {
        const {buttonClassName, type} = this.props;

        return {
            className: classnames(buttonClassName, 'dropdown--button'),
            dropdown: true,
            type,
        };
    }

    getProps() {
        const {className, displayDirection = 'down', dropdownRenderer} = this.props;

        return {
            className: classnames('dropdown', className),
            displayDirection,
            overlayRenderer: dropdownRenderer,
            triggerType: 'click',
        };
    }

    render() {
        const {children, displayDirection= 'down'} = this.props;

        return (
            <OverlayTrigger {...this.getProps()}>
                <Button {...this.getButtonProps()}>
                    {children} <Icon fontType="fa" iconName={`caret-${displayDirection}`} />
                </Button>
            </OverlayTrigger>
        );
    }
}

Dropdown.propTypes = {
    buttonClassName: PropTypes.string,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    displayDirection: PropTypes.string,
    dropdownRenderer: PropTypes.func.isRequired,
    type: PropTypes.string,
};
